import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import LoadingAbsolute from '../../LoadingAbsolute'
import Header from '../../Header'
import IconButtonComp from '../../IconButtonComp'
import SkeletonImage from '../../SkeletonImage'
import HobiFlowerSvg from '../../../assets/icons/HobiFlowerSvg'
import HistoryIconSvg from '../../../assets/icons/HistoryIconSvg'
import { useSelector } from 'react-redux'

const HobiBahceleriForm = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [flowerFocus, setFlowerFocus] = useState(false)
  const [hobiHistory, setHobiHistory] = useState(false)

  useEffect(() => {
    setLoading(false)
  }, [state])

  const PageState = useSelector((state) => state.PageState.value)

  return (
    <>
      {loading ? <LoadingAbsolute text={'Yükleniyor'} /> : null}
      <div className='hide-scrollbar'>
        <div
          style={{
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
          }}
        >
          <Header onClick={() => navigate('/')} />
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <SkeletonImage src={'https://app.yanibasimdakaratay.com/uploads/dijital_basvurular/' + PageState?.basvuru_fotografi} className='shadow' />
        </div>

        <div className='divider' />
        <>
          {PageState?.basvuru_aciklamasi ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                textAlign: 'center',
                marginTop: '1rem',
                marginBottom: '0.5rem',
                paddingLeft: '1rem',
                paddingRight: '1rem',
                paddingBottom: '0.5rem',
                fontSize: '0.9rem',
                color: '#535353',
              }}
            >
              {PageState?.basvuru_aciklamasi}
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                textAlign: 'center',
                marginBottom: '0.5rem',
                paddingLeft: '1rem',
                paddingRight: '1rem',
                paddingBottom: '0.5rem',
                fontSize: '0.9rem',
                color: '#535353',
              }}
            ></div>
          )}

          <IconButtonComp
            focus={flowerFocus}
            icon={<HobiFlowerSvg width={'1.2rem'} focus={flowerFocus} />}
            onClick={() => {
              setFlowerFocus(!flowerFocus)
              setHobiHistory(false)
              navigate('/hobiKosullar', {
                state: {
                  ucret: PageState?.ucret,
                },
              })
            }}
          >
            Başvuru Yap
          </IconButtonComp>
          <IconButtonComp
            focus={hobiHistory}
            icon={<HistoryIconSvg width={'1.3rem'} height={'1.3rem'} focus={hobiHistory} />}
            onClick={() => {
              setHobiHistory(true)
              setFlowerFocus(false)
              navigate('/hobiList', { state: {} })
            }}
          >
            Başvurularım
          </IconButtonComp>
        </>
      </div>
    </>
  )
}

export default HobiBahceleriForm
